import {
  ComboBox,
  ContextualMenu,
  DetailsListLayoutMode,
  Dialog,
  DialogFooter,
  FontSizes,
  FontWeights,
  getTheme,
  IButtonStyles,
  IColumn,
  IComboBox,
  IComboBoxOption,
  ICommandBarItemProps,
  Icon,
  IconButton,
  IDragOptions,
  IIconProps,
  mergeStyleSets,
  MessageBar,
  MessageBarButton,
  MessageBarType,
  Modal,
  NeutralColors,
  PanelType,
  Pivot,
  PivotItem,
  PrimaryButton,
  ProgressIndicator,
  SharedColors,
  TextField,
  TooltipHost,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Text } from "@fluentui/react/lib/Text";
import { IListaRol, IUserById } from "../../../Interfaces/IUsuario";
import usuarioServicio from "../../../services/usuarioService";
import axios from "axios";
import { TableBase } from "../../../components/Table/TableBase";
import IconHelper from "../../../utils/helpers/iconHelper";
import { IPagination } from "../../../Interfaces/base/ITable";
import {
  _initialFilter,
  _initialPagination,
} from "../../../utils/helpers/helpers";
import { Ifilter } from "../../../Interfaces/filter";
import { ConfigHelper } from "../../../utils/helpers/configHelper";
import { PanelAsignacionRoles } from "./PanelAsignacionRoles";
import { PanelEliminarRol } from "./PanelEliminarRol";
import { CuentasUser } from "./CuentasUser";
import HeaderTable from "../../../components/generic/HeaderTable";

const UsuarioCuenta = () => {
  const navigate = useNavigate();
  const state = useLocation();
  const usuarioState: any = state.state;
/*   const location = useLocation(); */
/*   const nombreUser= location.state; */
  const usuarioId =
    usuarioState && usuarioState != null ? usuarioState.usuarioId : "";
  const identityId =
    usuarioState && usuarioState != null ? usuarioState.identityId : "";
  const nombre =
    usuarioState && usuarioState != null ? usuarioState.nombre : "";
  const email = usuarioState && usuarioState != null ? usuarioState.email : "";

  // const [info, setInfo] = useState<IPersona>(null!);
  const [cargaTabla, setCargaTabla] = useState(false);

  const [totalItems, setTotalItems] = useState(0);
  const [itemsView, setitemsView] = useState(50);
  const [item, setItem] = useState<IListaRol[]>([]);
  // const persona: IPersona = state.state;
  // const [personaId, setPersonaId] = useState<string>(persona?.personaId ?? "");
  const controllerRef = useRef<AbortController>(new AbortController());

  const [
    isOpenAsignarRol,
    { setTrue: openPanelAsignarRol, setFalse: dismissPanelAsignarRol },
  ] = useBoolean(false);
  // const [filter, setFilter] = useState<IFilter>({
  //   skip: 0,
  //   take: 50,
  //   search: "",
  // });

  const [
    isOpenPanelEliminarRol,
    { setTrue: openPanelEliminarRol, setFalse: dismissPanelEliminarRol },
  ] = useBoolean(false);

  // const [modelUpdatePersonaRol, setModelUpdatePersonaRol] =
  //   useState<IUpdateUsuarioRol>({
  //     personaId: personaId,
  //   });

  const [keepInBounds, { toggle: toggleKeepInBounds }] = useBoolean(false);

  //panel
  const [isOpenCrearRol, { setTrue: openCrearRol, setFalse: dismissCrearRol }] =
    useBoolean(false);

  /* ------------- mensajes de estado -------------- */
  const [verLoading, setVerLoading] = useState(false);
  const [mensajeTransaccion, setMensajeTransaccion] = useState("");
  const [tipoMensaje, setTipoMensaje] = useState(0);
  const [verLoadingBoton, setVerLoadingBoton] = useState(false);
  const [activo, setActivo] = useState<boolean>(true);

  //aca
  const [filter, setFilter] = useState<Ifilter>(_initialFilter);
  const [rolSelected, setRolSelected] = useState<IListaRol>(null!);

  // useEffect(() => {
  //   if (personaId != "") {
  //     _alterTabla();
  //     dataPersona();
  //   } else {
  //     navigate(`/ssoma/personas/listado`);
  //   }
  // }, []);

  // const dataPersona = () => {
  //   if (persona && persona.personaId != "") {
  //     personaTokenService
  //       .personaByID(personaId)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           setInfo(res.data);
  //         }
  //       })
  //       .catch((e: IException) => {
  //         alert(splitExceptionDetail(e));
  //       });
  //   }
  // };
  useEffect(() => {
    if (isOpenCrearRol) {
      setTipoMensaje(3);
      setVerLoadingBoton(false);
    }
  }, [isOpenCrearRol]);

  useEffect(() => {
    getRolesByUser();
  }, []);

  // function loadTablaRolesPersona(filter) {
  //   controllerRef.current?.abort();
  //   const newController = new AbortController();
  //   controllerRef.current = newController;
  //   setCargaTabla(true);

  //   RolService.getRolesPersona({ personaId: personaId }, newController)
  //     .then((res) => {
  //       if (res.status == 200) {
  //         setIdentityId(res.data?.identityId);
  //         setItem(res.data?.role);
  //         setTotalItems(res.data?.role.length);
  //         setCargaTabla(false);
  //       }
  //     })
  //     .catch((e) => {
  //       if (axios.isCancel(e)) {
  //         console.log("Solicitud cancelada:", e?.message);
  //       } else {
  //         console.error("Error en la solicitud:", e?.message);
  //         setCargaTabla(false);
  //       }
  //     });
  // }

  const getRolesByUser = () => {
    setCargaTabla(true);

    usuarioServicio
      .rolesByUser({ userId: identityId })
      .then((res) => {
        if (res.status == 200) {
          // setIdentityId(res.data?.identityId);
          setItem(res.data);
          setTotalItems(res.data?.length);
          setCargaTabla(false);
        }
      })
      .catch((e) => {
        if (axios.isCancel(e)) {

        } else {
          console.error("Error en la solicitud:", e?.message);
          setCargaTabla(false);
        }
      });
  };

  // c

  // const _alterTabla = () => {
  //   loadTablaRolesPersona({
  //     skip: 0,
  //     take: 50,
  //     search: "",
  //   });
  // };

  // const columns = [
  //   { key: "descripcion", label: "Rol", ancho: "200px" },
  //   {
  //     key: "render",
  //     label: "Opciones",
  //     ancho: "100px",
  //     onRender: (item) => renderOpciones(item),
  //   },
  // ]

  // function renderOpciones(item) {
  //   return (
  //     <>
  //       <TooltipHost content={"Eliminar"}>
  //         <Button
  //           style={{
  //             fontSize: "17px",
  //             padding: "3px",
  //           }}
  //           appearance="transparent"
  //           icon={<Delete24Regular />}
  //           onClick={() => {
  //             setModelUpdatePersonaRol({
  //               ...modelUpdatePersonaRol,
  //               rol: item.descripcion,
  //               nombre: item.text,
  //               rolId: item.key,
  //             });
  //             openPanelEliminar();
  //       }}
  //         />
  //       </TooltipHost>
  //     </>
  //   );
  // }

  // const buttonRight: ObjectCommandBar[] = [
  //   {
  //     onClick: () => {
  //       window.history.back();
  //     },
  //     text: "Atrás",
  //     appearance: "subtle",
  //   },
  // ];

  // const buttonLeft: ObjectCommandBar[] = [
  //   {
  //       onClick: () => {
  //         openCrearRol();
  //       },
  //       text: "Nuevo",
  //       appearance: "subtle",
  //   },
  //   {
  //     onClick: () => {
  //       _alterTabla();
  //     },
  //     style: {
  //       zIndex: "99",
  //     },
  //     text: "Actualizar",
  //     appearance: "subtle",
  //   },
  // ];
  const _leftBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_BACK,
        onClick: () => {
          navigate(ConfigHelper.urlBase() + "/configuraciones/usuarios");
        },
      },
      {
        ...IconHelper.ICON_RELOAD,
        onClick: () => getRolesByUser(),
      },
      {
        ...IconHelper.ICON_ADD_TABLE,
        onClick: () => openPanelAsignarRol(),
      },
    ];

    return _items;
  };

  const _rigthBar = () => {
    const _items: ICommandBarItemProps[] = [];

    return _items;
  };

  const _column: IColumn[] = [
    {
      key: "text",
      name: "Rol",
      fieldName: "text",
      minWidth: 80,
      maxWidth: 200,
      isResizable: true,
    },

    {
      key: "column3",
      name: "Opciones",
      fieldName: "",
      minWidth: 40,
      maxWidth: 100,
      isResizable: true,
      onRender: (item) => {
        return (
          <>
            <div>
              <TooltipHost content="Eliminar">
                <Icon
                  style={{
                    color: SharedColors.red10,
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  iconName="Delete"
                  onClick={() => {
                    setRolSelected(item);
                    openPanelEliminarRol();
                  }}
                />
              </TooltipHost>
            </div>
          </>
        );
      },
    },
  ];

  const [currentPage, setCurrentPage] = React.useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = React.useState(_initialPagination().pageSize);

  const [pagIngreso, setPagIngreso] = React.useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => setCurrentPage(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  const _getPageSize = (value: number) => {

    setPageSize(value);
    setFilter({ ...filter, skip: (currentPage - 1) * pageSize, take: value });
    setPagIngreso({ ...pagIngreso, pageSize: value });
  };

  return (
    <>
      {/* <pre>{JSON.stringify(usuarioState, null, 2)}</pre> */}
      <div style={{padding:"10px"}}>
      <HeaderTable title={"Usuario"} subTitle={`${nombre} - ${email} `} hidenIcon={true} />

      </div>

      <Pivot aria-label="Basic Pivot Example">
        <PivotItem headerText="Cuentas">
          <CuentasUser usuarioId={usuarioId} />
        </PivotItem>
        <PivotItem
          headerText="Roles"
          headerButtonProps={{
            "data-order": 1,
            "data-title": "My Files Title",
          }}
        >
          <TableBase
            leftBar={_leftBar()}
            isLoading={cargaTabla}
            pagination={pagIngreso}
            data={item}
            getPageSize={_getPageSize}
            column={_column}
            layout={DetailsListLayoutMode.justified}
          />

          <div style={{ position: "absolute", bottom: 10, right: 0 }}>
            {/* <PaginationV9
                setFilter={setFilter}
                filter={filter}
                setItemsView={setitemsView}
                itemsView={itemsView}
                totalData={totalItems}
              /> */}
          </div>

          <PanelAsignacionRoles
            usuarioId={usuarioId}
            identityId={identityId}
            nombre={nombre}
            email={email}
            isOpen={isOpenAsignarRol}
            onDismiss={dismissPanelAsignarRol}
            onRenderTable={getRolesByUser}
            roles={item.map((x) => x.key.toLowerCase())}
          />

          <PanelEliminarRol
            identityId={identityId}
            isOpen={isOpenPanelEliminarRol}
            onDismiss={dismissPanelEliminarRol}
            onRenderTable={getRolesByUser}
            rol={rolSelected}
          />
        </PivotItem>
      </Pivot>
    </>
  );
};

export { UsuarioCuenta };
